// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.bestwallet",
    name: "Best Wallet",
    homepage: "https://bestwallet.com/",
    image_id: "7f9574ed-eb42-4e04-0888-be2939936700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/best-wallet/id6451312105",
        android: "https://play.google.com/store/apps/details?id=com.bestwallet.mobile",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "bw://app/connect",
        universal: "https://best-wallet-prod.web.app/connect",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map